import { FormParams } from '@/ui/features/forms/shared';
import { usePublicDataGet } from '@juvare/platform-sdk-react/ui/hooks';

export const useRmsFormParams = () => {
    const states = usePublicDataGet<FormParams['states']>('classifier-state').data ?? [];
    return { states };
};
